module.exports = "<div class=\"row\">\n  <div id=\"previewContainer\" class=\"row\">\n    <ng-template #container></ng-template>\n  </div>\n</div>\n"